import BookingsRepository from './entity/BookingsRepository'
import UsersRepository from './entity/UsersRepository'
import MessagesRepository from './entity/MessagesRepository'
import AdminRepository from '@/repositories/entity/AdminRepository'
import UploadRepository from '@/repositories/entity/UploadRepository'
import SettingsRepository from '@/repositories/entity/SettingsRepository'
import ServicesRepository from '@/repositories/entity/ServicesRepository'
import BranchesRepository from '@/repositories/entity/BranchesRepository'
import UserFieldSettingRepository  from "@/repositories/entity/UserFieldSettingRepository";
import FileRepository from '@/repositories/entity/FileRepository'
import StoreSettingRepository from "@/repositories/entity/StoreSettingRepository";
import LineMessagesRepository from "@/repositories/entity/LineMessagesRepository";
import MenuRepository from './entity/MenuRepository'
import HolidayRepository from '@/repositories/entity/HolidayRepository'
import notificationMessageTemplateRepository from '@/repositories/entity/NotificationMessageTemplateRepository'

const repositories = {
  bookings: BookingsRepository,
  users: UsersRepository,
  messages: MessagesRepository,
  admin: AdminRepository,
  upload: UploadRepository,
  settings: SettingsRepository,
  services: ServicesRepository,
  branches: BranchesRepository,
  userFieldSettings: UserFieldSettingRepository,
  file: FileRepository,
  storeSettings: StoreSettingRepository,
  lineMessage: LineMessagesRepository,
  menu: MenuRepository,
  holiday: HolidayRepository,
  notificationMessageTemplate: notificationMessageTemplateRepository,
}

export const RepositoryFactory = {
  get: (name) => repositories[name],
}
